import { ChevronDown } from 'lucide-react';
import React, { useState } from 'react';

export const SectionCard = ({
  title,
  icon,
  colapse = false,
  children,
}: {
  title: string;
  icon?: React.ReactNode;
  colapse?: boolean;
  children: React.ReactNode;
}) => {
  const [collapsed, setCollapsed] = useState<boolean>(colapse);

  return (
    <div className="bg-white dark:bg-slate-800/60 rounded-xl border border-slate-100 dark:border-slate-700/60 overflow-hidden">
      {/* HEADER */}
      <div
        onClick={() => setCollapsed(!collapsed)}
        className="flex items-center justify-between gap-2 px-4 py-2.5 border-b border-slate-100 dark:border-slate-700/60 bg-slate-50 dark:bg-slate-800/80 cursor-pointer"
      >
        <div className="flex items-center gap-2">
          {icon && (
            <span className="text-slate-400 dark:text-slate-500">{icon}</span>
          )}

          <div className="text-[11px] font-semibold tracking-widest text-slate-500 dark:text-slate-400 uppercase">
            {title}
          </div>
        </div>

        {/* CHEVRON */}
        <ChevronDown
          className={`w-4 h-4 text-slate-400 transition-transform duration-300 ${
            collapsed ? '-rotate-180' : 'rotate-0'
          }`}
        />
      </div>

      {/* CONTENT */}
      <div
        className={`
          transition-all duration-300 ease-in-out
          overflow-hidden
          ${collapsed ? 'max-h-0 opacity-0' : 'max-h-[4000px] opacity-100'}
        `}
      >
        <div className="px-4 py-3 space-y-1">{children}</div>
      </div>
    </div>
  );
};

export const KVRow = ({
  label,
  value,
  icon,
}: {
  label: string;
  value: React.ReactNode;
  icon?: React.ReactNode;
}) => (
  <div className="flex justify-between items-center py-0.5 gap-2">
    <div className="flex items-center gap-1.5 text-sm text-slate-500 shrink-0">
      {icon && <span className="opacity-60">{icon}</span>}
      {label}
    </div>
    <div className="text-sm font-medium text-slate-800 dark:text-slate-200 text-right min-w-0 truncate">
      {value}
    </div>
  </div>
);
